export default "__VITE_ASSET__DUiDz63D__"